import { createClient } from '@supabase/supabase-js'
import { type Database } from '../../shared/db/public.types'


const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

console.log('Supabase Client Init - URL:', supabaseUrl, 'Anon Key (first 5 chars):', supabaseAnonKey.substring(0, 5));

// Create a custom Supabase client that includes account ID in headers
/*export const createSupabaseClient = (accountId?: string) => {
  const headers: Record<string, string> = {}
  
  if (accountId) {
    headers['AccountId'] = accountId
  }

  return createClient(supabaseUrl, supabaseAnonKey, {
    global: {
      headers
    }
  })
}*/

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)

export type Tables = Database['public']['Tables']
export type Row<T extends keyof Tables> = Tables[T]['Row']
export type Insert<T extends keyof Tables> = Tables[T]['Insert']
export type Update<T extends keyof Tables> = Tables[T]['Update']